import {Pipe, PipeTransform} from '@angular/core';
import {GymListEntry} from '../model/gym-list-entry';
import {BoulderListEntry} from '../model/boulder-list-entry';

@Pipe({
  name: 'boulderSearch',
})
export class BoulderSearchPipe implements PipeTransform {

  transform(boulders: BoulderListEntry[], searchTerm: string): any[] {
    if (!boulders) {
      return [];
    }
    if (!searchTerm) {
      return boulders;
    }
    searchTerm = searchTerm.toLowerCase();
    return boulders.filter(boulder => {
      const boulderAsString = boulder.boulderName.toLowerCase() + ' ' + boulder.wallName.toLowerCase();
      return boulderAsString.includes(searchTerm);
    });
  }
}
